@if (initialized && dto) {

    @if (uiMode == 'side') {
        <mvs-cn-commission-rule-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [(activeNavigationItem)]="activeNavigationItem"
                (onNavigationItems)="handleNavigationItems($event)"
        ></mvs-cn-commission-rule-side>
    } @else {
        <mvs-cn-commission-rule-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [(activeNavigationItem)]="activeNavigationItem"
                (onNavigationItems)="handleNavigationItems($event)"
        ></mvs-cn-commission-rule-full>
    }

}
